// extracted by mini-css-extract-plugin
module.exports = {"generic":"modal_generic__xCwz3"};